import styled from '@emotion/styled';
import Link from 'next/link';
import React, { ReactNode, useRef } from 'react';
import { useOutsideClick } from '../../../../utils/hooks/useOutsideClick';
import { spacing } from '../../../../utils/styleguide';
import { HandleNavItemSelected } from '../../../contentful-elements/navigationbar/common';
import Typography from '../../text/Typography';
import { NavLinkItemType } from '../navTypes';
import LinkGroups from './LinksGroup';
import MobileNavBarWrapper from './MobileNavBarWrapper';

const LinkGroupsContainer = styled(LinkGroups)`
  margin: ${spacing[6]}px 0 ${spacing[4]}px;
`;

const MediaActionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: ${spacing[5]}px;
`;

const MediaActionItem = styled.div`
  margin-right: ${spacing[4]}px;
  :last-child {
    margin-right: 0;
  }
  a {
    margin-right: ${spacing[4]}px;
    :last-child {
      margin-right: 0;
    }
  }
`;

const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${spacing[2]}px 0;
`;

type Props = {
  isOpened: boolean;
  linkGroups?: NavLinkItemType[];
  handleNavItemClick: HandleNavItemSelected;
  button?: ReactNode | null;
  bottomLinks?: NavLinkItemType[];
  clickOutside: (event: MouseEvent) => void;
};

const MobileNavBar = ({
  isOpened,
  linkGroups,
  handleNavItemClick,
  button,
  bottomLinks,
  clickOutside,
}: Props) => {
  const mobileNavBarRef = useRef(null);
  useOutsideClick(mobileNavBarRef, clickOutside);
  return (
    <MobileNavBarWrapper isOpened={isOpened} ref={mobileNavBarRef}>
      <LinkGroupsContainer linkGroups={linkGroups} handleNavItemClick={handleNavItemClick} />
      <div>
        {button}
        <MediaActionContainer>
          {bottomLinks?.map(({ links, title, id }) => {
            return (
              <MediaActionItem key={id}>
                <Typography tag="p" variant="bodyBold">
                  {title}
                </Typography>
                <LinkContainer>
                  {links?.map(({ title, image, href }, index) => {
                    return (
                      <Link href={href as string} key={index}>
                        <a aria-label={title} onClick={() => handleNavItemClick({ type: 'click' })}>
                          {image}
                        </a>
                      </Link>
                    );
                  })}
                </LinkContainer>
              </MediaActionItem>
            );
          })}
        </MediaActionContainer>
      </div>
    </MobileNavBarWrapper>
  );
};

export default MobileNavBar;
